export default __webpack_public_path__ + "alberta-region.2469abf66c828da3bb65.svg";